<table class="table table-bordered text-center">
  <thead>
    <tr>
      <th></th>
      <th colspan="4">Software</th>
      <th colspan="5">Hardware</th>
      <th colspan="7" class="text-center">Cable</th>
    </tr>
    <tr>
      <th>Date</th>
      <!--  -->
      <th>Waiter</th>
      <th>Cash Register</th>
      <th>Main device</th>
      <th>Printer</th>
      <th>Fiscal Printer</th>
      <!--  -->
      <th>Phones</th>
      <th>Tablets</th>
      <th>Printers</th>
      <th>Fiscal Printers</th>
      <th>Routers</th>
      <!--  -->
      <th>1M</th>
      <th>5M</th>
      <th>10M</th>
      <th>20M</th>
      <th>50M</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of tableRows">
      <td>{{row.date}}</td>
      <td>{{(row.softWaiter > 0 ? row.softWaiter : '')}}</td>
      <td>{{(row.softCashRegister > 0 ? row.softCashRegister : '')}}</td>
      <td>{{(row.softMainDevice > 0 ? row.softMainDevice : '')}}</td>
      <td>{{(row.softPrinter > 0 ? row.softPrinter : '')}}</td>
      <td>{{(row.softFiscalPrinter > 0 ? row.softFiscalPrinter : '')}}</td>
      <td>{{(row.hardPhones > 0 ? row.hardPhones : '')}}</td>
      <td>{{(row.hardTables > 0 ? row.hardTables : '')}}</td>
      <td>{{(row.hardPrinters > 0 ? row.hardPrinters : '')}}</td>
      <td>{{(row.hardFiscalPrinters > 0 ? row.hardFiscalPrinters : '')}}</td>
      <td>{{(row.hardRouters > 0 ? row.hardRouters : '')}}</td>
      <td>{{(row.oneCable > 0 ? row.oneCable : '')}}</td>
      <td>{{(row.fiveCable > 0 ? row.fiveCable : '')}}</td>
      <td>{{(row.tenCable > 0 ? row.tenCable : '')}}</td>
      <td>{{(row.twentyCable > 0 ? row.twentyCable : '')}}</td>
      <td>{{(row.fiftyCable > 0 ? row.fiftyCable : '')}}</td>
    </tr>
  </tbody>
</table>
